import { defaultTimeout, IModel, IAttribute, IViolation, ModelConstants } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';

import { Pipeline } from 'app/model/pipeline/pipeline';
import { format, sanitizeAndFormatString } from 'app/shared/utils/string.util';
import { ValidationActivity } from 'app/model/pipeline/validation.activity';
import { ModelMarker } from 'app/model/services/state';

@Metamodel.model({
    name: ModelConstants.untilActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.UntilActivityLabel),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.UntilActivityLabel)
    ],
    referable: true,
    validator:  UntilActivity.unallowedTypesValidator
})
export class UntilActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly EXPRESSION: IAttribute;

    // This property should always be an Expression type.
    @Metamodel.attribute({
        display: stringResources.Expression,
        association: 'EXPRESSION',
        templatable: true,
        accepts: ['Bool'],
        constraint: {
            required: true
        }
    })
    public expression: string;

    @Metamodel.attribute({
        display: stringResources.Timeout,
        constraint: {
            pattern: new RegExp('^(\\d+\\.)?((0?\\d)|(1\\d)|(2[0-3]))(:[0-5]?\\d){2}$')
        }
    })
    public untilTimeout?: string = defaultTimeout;

    @Metamodel.attribute({
        display: stringResources.Pipeline,
        constraint: {
            required: true
        },
        type: Pipeline.MODEL
    })
    public pipeline?: Pipeline;

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ControlActivity';
    }

    private static unallowedTypesValidator(untilActivity?: UntilActivity): IViolation[] {
        const violations: IViolation[] = [];
        if (untilActivity && untilActivity.pipeline) {
            violations.push(...UntilActivity.findUnallowedTypeViolation(untilActivity.pipeline.activities));
        }
        return violations;
    }

    private static findUnallowedTypeViolation(activities: Set<Activity>): IViolation[] {
        const unallowedTypes = [ValidationActivity];
        const violations: IViolation[] = [];

        for (const activity of activities) {
            if (unallowedTypes.find((activityType) => activity instanceof activityType)) {
                const label = Metamodel.modelOf(activity).display[0];

                violations.push({
                    context: activity,
                    message: () => sanitizeAndFormatString(stringResources.UntilActivityUnallowedActivityError, label, activity.name),
                    revalidate: () => ModelMarker.isDeleted(activity)
                });
            }
        }

        return violations;
    }

    public onActivityCloned(clonedActivity: UntilActivity, context: { inlineDataset?: boolean }): void {
        if (this.pipeline.activities != null) {
            this.pipeline.activities.forEach((activity) => {
                const targetActivity = clonedActivity.pipeline?.activities?.find((targetActivity) => targetActivity.name === activity.name);
                if (targetActivity != null && activity instanceof Activity) {
                    activity.onActivityCloned(targetActivity, context);
                }
            })
        }
    }
}
